module.exports = __webpack_public_path__ + "static/media/home.d5d304b1.svg";